<template>
  <div class="receptionOverflow">
    <div class="flex">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部预约" name="second">
        </el-tab-pane>
        <el-tab-pane label="预约看板" name="first">
        </el-tab-pane>
        <el-tab-pane label="预约项目" name="third">
        </el-tab-pane>
        <el-tab-pane :label="'预约'+Lib.collectively()" name="fourth">
        </el-tab-pane>
      </el-tabs>
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: ''
    };
  },
  watch: {
    $route(e) {
      if (e.name == 'stage-singleDay') {
        this.activeName = 'first';
      } else if (e.name == 'stage-allDay') {
        this.activeName = 'second';
      } else if (e.name == 'stage-bespeakService') {
        this.activeName = 'third';
      } else if (e.name == 'stage-bespeakTechnician') {
        this.activeName = 'fourth';
      }
    }
  },
  activated() {
    const nowUrl = window.location.href;
    if (nowUrl.indexOf('singleDay') > -1) {
      this.activeName = 'first';
    } else if (nowUrl.indexOf('allDay') > -1) {
      this.activeName = 'second';
    } else if (nowUrl.indexOf('bespeakService') > -1) {
      this.activeName = 'third';
    } else if (nowUrl.indexOf('bespeakTechnician') > -1) {
      this.activeName = 'fourth';
    }
  },
  deactivated() {
    window.sessionStorage.bespeakId = '';
  },
  methods: {
    handleClick() {
      window.sessionStorage.bespeakId = '';
      if (this.activeName == 'first') {
        this.$router.push({
          name: 'stage-singleDay'
        });
      } else if (this.activeName == 'second') {
        this.$router.push({
          name: 'stage-allDay'
        });
      } else if (this.activeName == 'third') {
        this.$router.push({
          name: 'stage-bespeakService'
        });
      } else if (this.activeName == 'fourth') {
        this.$router.push({
          name: 'stage-bespeakTechnician'
        });
      }
    }
  },
};
</script>
